module.exports = __webpack_public_path__ + "static/media/icon-schedule-orange.1db281f1.svg";